import React from "react";

export default function PublicLayout({ children }) {
 

  return <><div className="h-screen bg-white">{children}</div><div id="google_translate_element"></div></>;
}
